import React from 'react';

import AppTitle from 'AppTitle';
import ClassNames from 'classnames';
import LanguageSelection from 'LanguageSelection';
import PropTypes from 'prop-types';
import { Translation, TranslationConsumer } from 'giro-react-toolkit/source/Translation';

import aboutIcon from "images/icon-about.svg";
import globeIcon from "images/icon-globe.svg";
import logo from "images/logo-light-background.svg";

import "./SlidingMenu.scss";

/**
 * Sliding menu component
 */
function SlidingMenu(props) {
   let classes = ClassNames(
      "sliding-menu",
      {"sliding-menu--closed": !props.show}
   );

   return (
      <div className={classes}>
         <div className="app-header">
            <AppTitle />
            <button className="close-menu button--icon-only button--icon-close-dark-bg"
               type="button" aria-label="close"
               onClick={props.onClose}></button>
         </div>
         <ul>
            <li>
               <button type="button" onClick={props.onAbout}>
                  <img src={aboutIcon}/>
                  <Translation resourceKey='ReachMapRes.InfoButtonText' />
               </button>
            </li>
            {/* Cacher la barre de langue quand il y a juste une langue */}
            <TranslationConsumer>
               {({ supportedCultures }) => {
                  return (
                     <React.Fragment >
                        {
                           supportedCultures.length > 1 &&
                           <li>
                              <img src={globeIcon}/>
                              <LanguageSelection inLineMode="true" className="small-device-language-bar" />
                           </li>
                        }
                     </React.Fragment>
                  );
               }}
            </TranslationConsumer>
            { /**
               * Show link to transit agency only if it is configured
               */
               reachMap.application.transitAgencySite && reachMap.application.transitAgencyName &&
               <li>
                  <a href={reachMap.application.transitAgencySite} target="_blank"><img src={logo}/>
                     {reachMap.application.transitAgencyName}
                  </a>
               </li>
            }
         </ul>
      </div>
   );
}

SlidingMenu.propTypes = {
   /**
    * @callback Callback for the about button
    */
   onAbout: PropTypes.func,
   /**
    * @callback Callback for the close menu button
    */
   onClose: PropTypes.func,
   /**
    * Show sliding menu
    */
   show: PropTypes.bool
}
export default SlidingMenu;
